<div #mapContainer class="map-container"></div>

<!-- Multi-Vehicle Speed Indicators -->
<div class="speed-indicators-container" *ngIf="vehicleSpeedData.length > 0">
  <div class="speed-indicator" *ngFor="let vehicle of vehicleSpeedData">
    <div class="speed-indicator-header">
      <div class="vehicle-color-dot" [style.background-color]="vehicle.color"></div>
      <span class="vehicle-registration">{{ vehicle.registration }}</span>
    </div>
    <div class="speed-bar-container">
      <div class="speed-bar-background">
        <div 
          class="speed-bar-fill" 
          [style.width.%]="getSpeedBarWidth(vehicle.speed)"
          [style.background-color]="getSpeedBarColor(vehicle.speed)">
        </div>
      </div>
      <span class="speed-value">{{ vehicle.speed }} km/h</span>
    </div>
  </div>
</div>
